import React, { Component } from "react";
import {getFavoriteTopics,addFavoriteTopics,removeFavoriteTopics} from '../config/Variables';
export default class FollowSectionSpecial extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      isLoading: true,
      users: [],
      numberstid: [],
      error: null,
      isList:false,
    }
    this.handleInputChange = this.handleInputChange.bind(this);


    if (localStorage.getItem('user-info')) {

    let user = JSON.parse(localStorage.getItem('user-info'))
    let datt = fetch(getFavoriteTopics, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        if(data.webmsg.code==401){
          localStorage.clear();
          var domainurl=  window.location.origin;
          window.location.href = domainurl+'/journey';
        }
        data.data.map(({ tid }, index2) => {
          this.state.numberstid.push(tid);
          //this.setState({ numberstid: [this.state.numberstid, tid] })
          this.setState({ numberstid: this.state.numberstid })
          this.state.hobbies.push(tid);
        });
      });
  }
}
  async   handleInputChange(event) {

    const target = event.target;
    var value = target.value;

    if (event.target.checked) {
    var tid = document.getElementById('section_id').getAttribute('data-value');
    const isList=false;

    let item = { tid,isList };
    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(addFavoriteTopics, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          var selectedId1='tagspecial'; 
          document.getElementById(selectedId1).innerHTML = "متابع";
          this.props.samirCallback("success");
          
        }
      }
    }
  }else{
    var tid = document.getElementById('section_id').getAttribute('data-value');


    const isList=false;
    let item = { tid,isList };
    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(removeFavoriteTopics, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          var selectedId='tagspecial'; 
          document.getElementById(selectedId).innerHTML = "<i class='icomoon-icon icon-plus-green'></i> تابع";
          this.props.samirCallback("success");
        }
      }
    }




  }
  }

  render() {
    const {
      users,
      error,
      numberstid
    } = this.state;
      if (localStorage.getItem('user-info')) {
    var tid = document.getElementById('section_id').getAttribute('data-value');
  
    const answer_array = tid.split(',');
   
    const fruitss = this.state.numberstid;
    const ttt = parseInt(tid);
   // if(fruitss.includes(answer_array[0]) &&  fruitss.includes(answer_array[1])  ){
   // const ss = fruitss.includes(ttt); //true
   // }
    
    if(fruitss.includes(answer_array[0]) &&  fruitss.includes(answer_array[1])  ){
    return (
      <>
          <label for="follow-tag" class="follow-tag">
          <input type="checkbox" id="follow-tag" name="tag" defaultChecked={true} onTouchEnd={this.handleInputChange} onClick={this.handleInputChange} class="form-check"/>
          <div  id="tagspecial" class="button small rounded follow-check">متابع</div>
      </label> 
      </>

    );
  }else{
    return (
       <>
       <label for="follow-tag" class="follow-tag">
       <input type="checkbox" id="follow-tag" name="tag"  onTouchEnd={this.handleInputChange} onClick={this.handleInputChange} class="form-check"/>
       <div  id="tagspecial" class="button small rounded follow-check"> <i class="icomoon-icon icon-plus-green"></i> تابع</div>
   </label> 
   </>
    );
    }
  }else{
    return (
      <>
      <label for="follow-tag" class="follow-tag">
      <input type="checkbox" id="follow-tag" name="tag" class="form-check modal-toggle" data-id="modal-notification"/>
      <div  id="tagspecial" class="button small rounded follow-check"> <i class="icomoon-icon icon-plus-green"></i> تابع</div>
  </label> 
  </>
    );
  }
}
}
